module.exports = __webpack_public_path__ + "static/media/vegan.88d0561e.jpg";